module.exports = __webpack_public_path__ + "img/Guatemala.d9ebb8a8.png";